// frontend/modules/account-settings/index.ts
import { ModuleConfig } from '@/core/module';
import { accountSettingsRoutes } from './routes';

export const AccountSettingsModule: ModuleConfig = {
    name: 'account-settings',
    routes: accountSettingsRoutes,
    initialize: () => {
        console.log('Account Settings module initialized');
    }
};